export const Features = (props) => {
  return (
    <div id='features' className='text-center'>
      <div className='container'>
        {/* Section Title */}
        <div className='col-md-10 col-md-offset-1 section-title'>
          <h2>{props.data?.sectionTitle || 'Features'}</h2>
        </div>
        {/* Features List */}
        <div className='row'>
          {props.data?.items
            ? props.data.items.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-6 col-md-3'>
                  {' '}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  );
};